@if (isLoading()) {
  <div class="inline-loading-overlay" role="status" aria-live="polite">
    <div class="inline-loading-card flex flex-col items-center gap-2">
      <mat-spinner [diameter]="diameter()"></mat-spinner>
      <p class="inline-loading-text">
        @if (activeMessageKey()) {
          {{ activeMessageKey() | translate }}
        } @else {
          {{ 'common.loading' | translate }}
        }
      </p>
    </div>
  </div>
}
